// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from "./client";
import { client } from "./client.gen";
import type {
    AuthorizedCallbackRouteData_api,
    AuthorizedCallbackRouteResponses_api,
    CreateSessionData_api,
    CreateSessionErrors_api,
    CreateSessionResponses_api,
    CreateSnapshotData_api,
    CreateSnapshotErrors_api,
    CreateSnapshotResponses_api,
    DeleteSessionData_api,
    DeleteSessionErrors_api,
    DeleteSessionResponses_api,
    DeleteSnapshotAccessLogData_api,
    DeleteSnapshotAccessLogErrors_api,
    DeleteSnapshotAccessLogResponses_api,
    DeleteSnapshotData_api,
    DeleteSnapshotErrors_api,
    DeleteSnapshotResponses_api,
    GetAliveData_api,
    GetAliveProtectedData_api,
    GetAliveProtectedResponses_api,
    GetAliveResponses_api,
    GetAssetInfosData_api,
    GetAssetInfosResponses_api,
    GetCasesData_api,
    GetCasesErrors_api,
    GetCasesResponses_api,
    GetDeltaEnsembleRealizationsVectorDataData_api,
    GetDeltaEnsembleRealizationsVectorDataErrors_api,
    GetDeltaEnsembleRealizationsVectorDataResponses_api,
    GetDeltaEnsembleStatisticalVectorDataData_api,
    GetDeltaEnsembleStatisticalVectorDataErrors_api,
    GetDeltaEnsembleStatisticalVectorDataResponses_api,
    GetDeltaEnsembleVectorListData_api,
    GetDeltaEnsembleVectorListErrors_api,
    GetDeltaEnsembleVectorListResponses_api,
    GetDeltaSurfaceDataData_api,
    GetDeltaSurfaceDataErrors_api,
    GetDeltaSurfaceDataResponses_api,
    GetDrilledWellboreHeadersData_api,
    GetDrilledWellboreHeadersErrors_api,
    GetDrilledWellboreHeadersResponses_api,
    GetEnsembleDetailsData_api,
    GetEnsembleDetailsErrors_api,
    GetEnsembleDetailsResponses_api,
    GetFieldIdentifiersData_api,
    GetFieldIdentifiersResponses_api,
    GetFieldPerforationsData_api,
    GetFieldPerforationsErrors_api,
    GetFieldPerforationsResponses_api,
    GetFieldScreensData_api,
    GetFieldScreensErrors_api,
    GetFieldScreensResponses_api,
    GetGridModelsInfoData_api,
    GetGridModelsInfoErrors_api,
    GetGridModelsInfoResponses_api,
    GetGridParameterData_api,
    GetGridParameterErrors_api,
    GetGridParameterResponses_api,
    GetGridSurfaceData_api,
    GetGridSurfaceErrors_api,
    GetGridSurfaceResponses_api,
    GetHistoricalVectorDataData_api,
    GetHistoricalVectorDataErrors_api,
    GetHistoricalVectorDataResponses_api,
    GetInitialFluidContactSurfacesMetadataData_api,
    GetInitialFluidContactSurfacesMetadataErrors_api,
    GetInitialFluidContactSurfacesMetadataResponses_api,
    GetInjectionDataData_api,
    GetInjectionDataErrors_api,
    GetInjectionDataResponses_api,
    GetInplaceTableDefinitionsData_api,
    GetInplaceTableDefinitionsErrors_api,
    GetInplaceTableDefinitionsResponses_api,
    GetLogCurveDataData_api,
    GetLogCurveDataErrors_api,
    GetLogCurveDataResponses_api,
    GetLoggedInUserData_api,
    GetLoggedInUserErrors_api,
    GetLoggedInUserResponses_api,
    GetMediaSasTokenData_api,
    GetMediaSasTokenResponses_api,
    GetMisfitSurfaceDataData_api,
    GetMisfitSurfaceDataErrors_api,
    GetMisfitSurfaceDataResponses_api,
    GetObservedSurfacesMetadataData_api,
    GetObservedSurfacesMetadataErrors_api,
    GetObservedSurfacesMetadataResponses_api,
    GetParametersAndSensitivitiesData_api,
    GetParametersAndSensitivitiesErrors_api,
    GetParametersAndSensitivitiesResponses_api,
    GetPlannedWellboreHeadersData_api,
    GetPlannedWellboreHeadersErrors_api,
    GetPlannedWellboreHeadersResponses_api,
    GetPlannedWellTrajectoriesData_api,
    GetPlannedWellTrajectoriesErrors_api,
    GetPlannedWellTrajectoriesResponses_api,
    GetPolygonsDataData_api,
    GetPolygonsDataErrors_api,
    GetPolygonsDataResponses_api,
    GetPolygonsDirectoryData_api,
    GetPolygonsDirectoryErrors_api,
    GetPolygonsDirectoryResponses_api,
    GetProductionDataData_api,
    GetProductionDataErrors_api,
    GetProductionDataResponses_api,
    GetPvtTableDataData_api,
    GetPvtTableDataErrors_api,
    GetPvtTableDataResponses_api,
    GetRealizationFlowNetworkData_api,
    GetRealizationFlowNetworkErrors_api,
    GetRealizationFlowNetworkResponses_api,
    GetRealizationSurfacesMetadataData_api,
    GetRealizationSurfacesMetadataErrors_api,
    GetRealizationSurfacesMetadataResponses_api,
    GetRealizationsVectorDataData_api,
    GetRealizationsVectorDataErrors_api,
    GetRealizationsVectorDataResponses_api,
    GetRelpermRealizationDataData_api,
    GetRelpermRealizationDataErrors_api,
    GetRelpermRealizationDataResponses_api,
    GetRelpermTableDefinitionData_api,
    GetRelpermTableDefinitionErrors_api,
    GetRelpermTableDefinitionResponses_api,
    GetRelpermTableNamesData_api,
    GetRelpermTableNamesErrors_api,
    GetRelpermTableNamesResponses_api,
    GetRftObservationsData_api,
    GetRftObservationsErrors_api,
    GetRftObservationsResponses_api,
    GetRftRealizationDataData_api,
    GetRftRealizationDataErrors_api,
    GetRftRealizationDataResponses_api,
    GetRftTableDefinitionData_api,
    GetRftTableDefinitionErrors_api,
    GetRftTableDefinitionResponses_api,
    GetSeismicCubeMetaListData_api,
    GetSeismicCubeMetaListErrors_api,
    GetSeismicCubeMetaListResponses_api,
    GetSeismicSlicesData_api,
    GetSeismicSlicesErrors_api,
    GetSeismicSlicesResponses_api,
    GetSessionData_api,
    GetSessionErrors_api,
    GetSessionMetadataData_api,
    GetSessionMetadataErrors_api,
    GetSessionMetadataResponses_api,
    GetSessionResponses_api,
    GetSessionsMetadataData_api,
    GetSessionsMetadataErrors_api,
    GetSessionsMetadataResponses_api,
    GetSnapshotAccessLogsData_api,
    GetSnapshotAccessLogsErrors_api,
    GetSnapshotAccessLogsResponses_api,
    GetSnapshotData_api,
    GetSnapshotErrors_api,
    GetSnapshotResponses_api,
    GetSnapshotsMetadataData_api,
    GetSnapshotsMetadataErrors_api,
    GetSnapshotsMetadataResponses_api,
    GetStatisticalSurfaceDataHybridData_api,
    GetStatisticalSurfaceDataHybridErrors_api,
    GetStatisticalSurfaceDataHybridResponses_api,
    GetStatisticalVectorDataData_api,
    GetStatisticalVectorDataErrors_api,
    GetStatisticalVectorDataPerSensitivityData_api,
    GetStatisticalVectorDataPerSensitivityErrors_api,
    GetStatisticalVectorDataPerSensitivityResponses_api,
    GetStatisticalVectorDataResponses_api,
    GetSummaryObservationsData_api,
    GetSummaryObservationsErrors_api,
    GetSummaryObservationsResponses_api,
    GetSurfaceDataData_api,
    GetSurfaceDataErrors_api,
    GetSurfaceDataResponses_api,
    GetUserInfoData_api,
    GetUserInfoErrors_api,
    GetUserInfoResponses_api,
    GetUserPhotoData_api,
    GetUserPhotoErrors_api,
    GetUserPhotoResponses_api,
    GetVectorListData_api,
    GetVectorListErrors_api,
    GetVectorListResponses_api,
    GetVfpTableData_api,
    GetVfpTableErrors_api,
    GetVfpTableResponses_api,
    GetVfpTablesData_api,
    GetVfpTablesErrors_api,
    GetVfpTablesResponses_api,
    GetWellboreCasingsData_api,
    GetWellboreCasingsErrors_api,
    GetWellboreCasingsResponses_api,
    GetWellboreCompletionsData_api,
    GetWellboreCompletionsErrors_api,
    GetWellboreCompletionsResponses_api,
    GetWellboreLogCurveHeadersData_api,
    GetWellboreLogCurveHeadersErrors_api,
    GetWellboreLogCurveHeadersResponses_api,
    GetWellborePerforationsData_api,
    GetWellborePerforationsErrors_api,
    GetWellborePerforationsResponses_api,
    GetWellborePickIdentifiersData_api,
    GetWellborePickIdentifiersErrors_api,
    GetWellborePickIdentifiersResponses_api,
    GetWellborePicksForPickIdentifierData_api,
    GetWellborePicksForPickIdentifierErrors_api,
    GetWellborePicksForPickIdentifierResponses_api,
    GetWellborePicksInStratColumnData_api,
    GetWellborePicksInStratColumnErrors_api,
    GetWellborePicksInStratColumnResponses_api,
    GetWellboreStratigraphicColumnsData_api,
    GetWellboreStratigraphicColumnsErrors_api,
    GetWellboreStratigraphicColumnsResponses_api,
    GetWellCompletionsDataData_api,
    GetWellCompletionsDataErrors_api,
    GetWellCompletionsDataResponses_api,
    GetWellTrajectoriesData_api,
    GetWellTrajectoriesErrors_api,
    GetWellTrajectoriesResponses_api,
    LoginRouteData_api,
    LoginRouteErrors_api,
    LoginRouteResponses_api,
    PostGetAggregatedPerRealizationInplaceTableDataData_api,
    PostGetAggregatedPerRealizationInplaceTableDataErrors_api,
    PostGetAggregatedPerRealizationInplaceTableDataResponses_api,
    PostGetAggregatedStatisticalInplaceTableDataData_api,
    PostGetAggregatedStatisticalInplaceTableDataErrors_api,
    PostGetAggregatedStatisticalInplaceTableDataResponses_api,
    PostGetPolylineIntersectionData_api,
    PostGetPolylineIntersectionErrors_api,
    PostGetPolylineIntersectionResponses_api,
    PostGetSampleSurfaceInPointsData_api,
    PostGetSampleSurfaceInPointsErrors_api,
    PostGetSampleSurfaceInPointsResponses_api,
    PostGetSeismicFenceData_api,
    PostGetSeismicFenceErrors_api,
    PostGetSeismicFenceResponses_api,
    PostGetSurfaceIntersectionData_api,
    PostGetSurfaceIntersectionErrors_api,
    PostGetSurfaceIntersectionResponses_api,
    PostGetWellTrajectoriesFormationSegmentsData_api,
    PostGetWellTrajectoriesFormationSegmentsErrors_api,
    PostGetWellTrajectoriesFormationSegmentsResponses_api,
    PostLogoutData_api,
    PostLogoutResponses_api,
    PostRefreshFingerprintsForEnsemblesData_api,
    PostRefreshFingerprintsForEnsemblesErrors_api,
    PostRefreshFingerprintsForEnsemblesResponses_api,
    RootData_api,
    RootResponses_api,
    UpdateSessionData_api,
    UpdateSessionErrors_api,
    UpdateSessionResponses_api,
} from "./types.gen";

export type Options<
    TData extends TDataShape = TDataShape,
    ThrowOnError extends boolean = boolean,
    TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get Asset Infos
 *
 * Get list of asset infos
 */
export const getAssetInfos = <ThrowOnError extends boolean = false>(
    options?: Options<GetAssetInfosData_api, ThrowOnError>,
): RequestResult<GetAssetInfosResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<GetAssetInfosResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/asset_infos",
        ...options,
        query: { ...options?.query, _schema: "0a58037305788155" },
    });

/**
 * Get Field Identifiers
 *
 * Get list of field identifiers
 */
export const getFieldIdentifiers = <ThrowOnError extends boolean = false>(
    options?: Options<GetFieldIdentifiersData_api, ThrowOnError>,
): RequestResult<GetFieldIdentifiersResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<GetFieldIdentifiersResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/field_identifiers",
        ...options,
        query: { ...options?.query, _schema: "364c1afc4d1268d6" },
    });

/**
 * Get Cases
 *
 * Get list of cases for specified asset
 */
export const getCases = <ThrowOnError extends boolean = false>(
    options: Options<GetCasesData_api, ThrowOnError>,
): RequestResult<GetCasesResponses_api, GetCasesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetCasesResponses_api, GetCasesErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/cases",
        ...options,
        query: { ...options.query, _schema: "77c97f183a1430fb" },
    });

/**
 * Get Ensemble Details
 *
 * Get more detailed information for an ensemble
 */
export const getEnsembleDetails = <ThrowOnError extends boolean = false>(
    options: Options<GetEnsembleDetailsData_api, ThrowOnError>,
): RequestResult<GetEnsembleDetailsResponses_api, GetEnsembleDetailsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetEnsembleDetailsResponses_api, GetEnsembleDetailsErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/cases/{case_uuid}/ensembles/{ensemble_name}",
        ...options,
        query: { ...options.query, _schema: "b454e91c68a48fe2" },
    });

/**
 * Post Refresh Fingerprints For Ensembles
 *
 * Retrieves freshly calculated fingerprints for a list of ensembles
 */
export const postRefreshFingerprintsForEnsembles = <ThrowOnError extends boolean = false>(
    options: Options<PostRefreshFingerprintsForEnsemblesData_api, ThrowOnError>,
): RequestResult<
    PostRefreshFingerprintsForEnsemblesResponses_api,
    PostRefreshFingerprintsForEnsemblesErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).post<
        PostRefreshFingerprintsForEnsemblesResponses_api,
        PostRefreshFingerprintsForEnsemblesErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/ensembles/refresh_fingerprints",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Vector List
 *
 * Get list of all vectors in a given Sumo ensemble, excluding any historical vectors
 *
 * Optionally include derived vectors.
 */
export const getVectorList = <ThrowOnError extends boolean = false>(
    options: Options<GetVectorListData_api, ThrowOnError>,
): RequestResult<GetVectorListResponses_api, GetVectorListErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetVectorListResponses_api, GetVectorListErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/timeseries/vector_list/",
        ...options,
        query: { ...options.query, _schema: "2ae3f77fb7f3f5e1" },
    });

/**
 * Get Delta Ensemble Vector List
 *
 * Get list of all vectors for a delta ensemble based on all vectors in a given Sumo ensemble, excluding any historical vectors
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleVectorList = <ThrowOnError extends boolean = false>(
    options: Options<GetDeltaEnsembleVectorListData_api, ThrowOnError>,
): RequestResult<GetDeltaEnsembleVectorListResponses_api, GetDeltaEnsembleVectorListErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetDeltaEnsembleVectorListResponses_api,
        GetDeltaEnsembleVectorListErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/delta_ensemble_vector_list/",
        ...options,
        query: { ...options.query, _schema: "9ce91f2628617eb7" },
    });

/**
 * Get Realizations Vector Data
 *
 * Get vector data per realization
 */
export const getRealizationsVectorData = <ThrowOnError extends boolean = false>(
    options: Options<GetRealizationsVectorDataData_api, ThrowOnError>,
): RequestResult<GetRealizationsVectorDataResponses_api, GetRealizationsVectorDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetRealizationsVectorDataResponses_api,
        GetRealizationsVectorDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/realizations_vector_data/",
        ...options,
        query: { ...options.query, _schema: "b0f4b7f052960daf" },
    });

/**
 * Get Delta Ensemble Realizations Vector Data
 *
 * Get vector data per realization
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleRealizationsVectorData = <ThrowOnError extends boolean = false>(
    options: Options<GetDeltaEnsembleRealizationsVectorDataData_api, ThrowOnError>,
): RequestResult<
    GetDeltaEnsembleRealizationsVectorDataResponses_api,
    GetDeltaEnsembleRealizationsVectorDataErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetDeltaEnsembleRealizationsVectorDataResponses_api,
        GetDeltaEnsembleRealizationsVectorDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/delta_ensemble_realizations_vector_data/",
        ...options,
        query: { ...options.query, _schema: "557d6b620f195bbf" },
    });

/**
 * Get Historical Vector Data
 */
export const getHistoricalVectorData = <ThrowOnError extends boolean = false>(
    options: Options<GetHistoricalVectorDataData_api, ThrowOnError>,
): RequestResult<GetHistoricalVectorDataResponses_api, GetHistoricalVectorDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetHistoricalVectorDataResponses_api,
        GetHistoricalVectorDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/historical_vector_data/",
        ...options,
        query: { ...options.query, _schema: "e58ec28b088f3633" },
    });

/**
 * Get Statistical Vector Data
 *
 * Get statistical vector data for an ensemble
 */
export const getStatisticalVectorData = <ThrowOnError extends boolean = false>(
    options: Options<GetStatisticalVectorDataData_api, ThrowOnError>,
): RequestResult<GetStatisticalVectorDataResponses_api, GetStatisticalVectorDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetStatisticalVectorDataResponses_api,
        GetStatisticalVectorDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/statistical_vector_data/",
        ...options,
        query: { ...options.query, _schema: "e5a22f95df6d347a" },
    });

/**
 * Get Delta Ensemble Statistical Vector Data
 *
 * Get statistical vector data for an ensemble
 *
 * Definition:
 *
 * delta_ensemble = comparison_ensemble - reference_ensemble
 */
export const getDeltaEnsembleStatisticalVectorData = <ThrowOnError extends boolean = false>(
    options: Options<GetDeltaEnsembleStatisticalVectorDataData_api, ThrowOnError>,
): RequestResult<
    GetDeltaEnsembleStatisticalVectorDataResponses_api,
    GetDeltaEnsembleStatisticalVectorDataErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetDeltaEnsembleStatisticalVectorDataResponses_api,
        GetDeltaEnsembleStatisticalVectorDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/delta_ensemble_statistical_vector_data/",
        ...options,
        query: { ...options.query, _schema: "e5a22f95df6d347a" },
    });

/**
 * Get Statistical Vector Data Per Sensitivity
 *
 * Get statistical vector data for an ensemble per sensitivity
 */
export const getStatisticalVectorDataPerSensitivity = <ThrowOnError extends boolean = false>(
    options: Options<GetStatisticalVectorDataPerSensitivityData_api, ThrowOnError>,
): RequestResult<
    GetStatisticalVectorDataPerSensitivityResponses_api,
    GetStatisticalVectorDataPerSensitivityErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetStatisticalVectorDataPerSensitivityResponses_api,
        GetStatisticalVectorDataPerSensitivityErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/timeseries/statistical_vector_data_per_sensitivity/",
        ...options,
        query: { ...options.query, _schema: "2e3104358c1bfb97" },
    });

/**
 * Get Inplace Table Definitions
 *
 * Get the inplace volumes tables definitions for a given ensemble.
 */
export const getInplaceTableDefinitions = <ThrowOnError extends boolean = false>(
    options: Options<GetInplaceTableDefinitionsData_api, ThrowOnError>,
): RequestResult<GetInplaceTableDefinitionsResponses_api, GetInplaceTableDefinitionsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetInplaceTableDefinitionsResponses_api,
        GetInplaceTableDefinitionsErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/inplace_volumes/inplace_table_definitions/",
        ...options,
        query: { ...options.query, _schema: "54ac4cbe78bd4eaf" },
    });

/**
 * Post Get Aggregated Per Realization Inplace Table Data
 *
 * Get aggregated inplace volume data for a given table with data per realization based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedPerRealizationInplaceTableData = <ThrowOnError extends boolean = false>(
    options: Options<PostGetAggregatedPerRealizationInplaceTableDataData_api, ThrowOnError>,
): RequestResult<
    PostGetAggregatedPerRealizationInplaceTableDataResponses_api,
    PostGetAggregatedPerRealizationInplaceTableDataErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).post<
        PostGetAggregatedPerRealizationInplaceTableDataResponses_api,
        PostGetAggregatedPerRealizationInplaceTableDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/inplace_volumes/get_aggregated_per_realization_inplace_table_data/",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Post Get Aggregated Statistical Inplace Table Data
 *
 * Get statistical inplace volumes data across selected realizations for a given table based on requested results and categories/index filter.
 *
 * Note: This endpoint is a post endpoint because the list of indices with values can be quite large and may exceed the query string limit.
 * As the endpoint is post, the indices with values object is kept for convenience.
 */
export const postGetAggregatedStatisticalInplaceTableData = <ThrowOnError extends boolean = false>(
    options: Options<PostGetAggregatedStatisticalInplaceTableDataData_api, ThrowOnError>,
): RequestResult<
    PostGetAggregatedStatisticalInplaceTableDataResponses_api,
    PostGetAggregatedStatisticalInplaceTableDataErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).post<
        PostGetAggregatedStatisticalInplaceTableDataResponses_api,
        PostGetAggregatedStatisticalInplaceTableDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/inplace_volumes/get_aggregated_statistical_inplace_table_data/",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Realization Surfaces Metadata
 *
 * Get metadata for realization surfaces in a Sumo ensemble
 */
export const getRealizationSurfacesMetadata = <ThrowOnError extends boolean = false>(
    options: Options<GetRealizationSurfacesMetadataData_api, ThrowOnError>,
): RequestResult<GetRealizationSurfacesMetadataResponses_api, GetRealizationSurfacesMetadataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetRealizationSurfacesMetadataResponses_api,
        GetRealizationSurfacesMetadataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/realization_surfaces_metadata/",
        ...options,
        query: { ...options.query, _schema: "8fec2505f04ba684" },
    });

/**
 * Get Observed Surfaces Metadata
 *
 * Get metadata for observed surfaces in a Sumo case
 */
export const getObservedSurfacesMetadata = <ThrowOnError extends boolean = false>(
    options: Options<GetObservedSurfacesMetadataData_api, ThrowOnError>,
): RequestResult<GetObservedSurfacesMetadataResponses_api, GetObservedSurfacesMetadataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetObservedSurfacesMetadataResponses_api,
        GetObservedSurfacesMetadataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/observed_surfaces_metadata/",
        ...options,
        query: { ...options.query, _schema: "8fec2505f04ba684" },
    });

/**
 * Get Initial Fluid Contact Surfaces Metadata
 *
 * Get metadata for the initial fluid contact surfaces in a Sumo ensemble
 */
export const getInitialFluidContactSurfacesMetadata = <ThrowOnError extends boolean = false>(
    options: Options<GetInitialFluidContactSurfacesMetadataData_api, ThrowOnError>,
): RequestResult<
    GetInitialFluidContactSurfacesMetadataResponses_api,
    GetInitialFluidContactSurfacesMetadataErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetInitialFluidContactSurfacesMetadataResponses_api,
        GetInitialFluidContactSurfacesMetadataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/initial_fluid_contact_surfaces_metadata/",
        ...options,
        query: { ...options.query, _schema: "4ca1180f5955a673" },
    });

/**
 * Get Surface Data
 *
 * Get surface data for the specified surface.
 *
 * ---
 * *General description of the types of surface addresses that exist. The specific address types supported by this endpoint can be a subset of these.*
 *
 * - *REAL* - Realization surface address. Addresses a specific realization surface within an ensemble. Always specifies a single realization number
 * - *OBS* - Observed surface address. Addresses an observed surface which is not associated with any specific ensemble.
 * - *STAT* - Statistical surface address. Fully specifies a statistical surface, including the statistic function and which realizations to include.
 *
 * Structure of the different types of address strings:
 *
 * ```
 * REAL~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<realization>[~~<iso_date_or_interval>]
 * STAT~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<stat_function>~~<stat_realizations>[~~<iso_date_or_interval>]
 * OBS~~<case_uuid>~~<surface_name>~~<attribute>~~<iso_date_or_interval>
 * ```
 *
 * The `<attribute>` component always spans three sub-components and says how the surface is identified:
 *
 * ```
 * TAGNAME~~<tagname>~~-
 * STDRES~~<standard_result>~~<sub_name>
 * ```
 *
 * A *TAGNAME* attribute matches the free text tagname the surface was exported with. A *STDRES* attribute matches an
 * FMU standard result, where `<sub_name>` discriminates between surfaces within that standard result, for example the
 * contact type for `fluid_contact_surface`. Unused components are set to "-".
 *
 * The `<stat_realizations>` component in a *STAT* address contains the list of realizations to include in the statistics
 * encoded as a `UintListStr` or "*" to include all realizations.
 */
export const getSurfaceData = <ThrowOnError extends boolean = false>(
    options: Options<GetSurfaceDataData_api, ThrowOnError>,
): RequestResult<GetSurfaceDataResponses_api, GetSurfaceDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSurfaceDataResponses_api, GetSurfaceDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/surface/surface_data",
        ...options,
        query: { ...options.query, _schema: "1a245c4e7075e0d3" },
    });

/**
 * Post Get Well Trajectories Formation Segments
 *
 * Get well trajectory formation segments.
 *
 * Provide a top bounding depth surface and an optional bottom bounding depth surface to define a
 * formation (area between two surfaces in depth). If bottom surface is not provided, the formation
 * is considered to extend down to the end of the well trajectory, i.e. end of well trajectory is
 * used as lower bound for formation.
 *
 * For each well trajectory, the segments where the well is within the formation are calculated and
 * returned. Each segment contains the measured depth (md) values where the well enters and exits
 * the formation.
 *
 * NOTE: Expecting depth surfaces, no verification is done to ensure that the surfaces are indeed
 * depth surfaces.
 */
export const postGetWellTrajectoriesFormationSegments = <ThrowOnError extends boolean = false>(
    options: Options<PostGetWellTrajectoriesFormationSegmentsData_api, ThrowOnError>,
): RequestResult<
    PostGetWellTrajectoriesFormationSegmentsResponses_api,
    PostGetWellTrajectoriesFormationSegmentsErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).post<
        PostGetWellTrajectoriesFormationSegmentsResponses_api,
        PostGetWellTrajectoriesFormationSegmentsErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/get_well_trajectories_formation_segments",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Statistical Surface Data Hybrid
 */
export const getStatisticalSurfaceDataHybrid = <ThrowOnError extends boolean = false>(
    options: Options<GetStatisticalSurfaceDataHybridData_api, ThrowOnError>,
): RequestResult<
    GetStatisticalSurfaceDataHybridResponses_api,
    GetStatisticalSurfaceDataHybridErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetStatisticalSurfaceDataHybridResponses_api,
        GetStatisticalSurfaceDataHybridErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/statistical_surface_data_hybrid",
        ...options,
        query: { ...options.query, _schema: "2c5234d2fcf9b516" },
    });

/**
 * Post Get Surface Intersection
 *
 * Get surface intersection data for the specified surface.
 *
 * ---
 * *General description of the types of surface addresses that exist. The specific address types supported by this endpoint can be a subset of these.*
 *
 * - *REAL* - Realization surface address. Addresses a specific realization surface within an ensemble. Always specifies a single realization number
 * - *OBS* - Observed surface address. Addresses an observed surface which is not associated with any specific ensemble.
 * - *STAT* - Statistical surface address. Fully specifies a statistical surface, including the statistic function and which realizations to include.
 *
 * Structure of the different types of address strings:
 *
 * ```
 * REAL~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<realization>[~~<iso_date_or_interval>]
 * STAT~~<case_uuid>~~<ensemble>~~<surface_name>~~<attribute>~~<stat_function>~~<stat_realizations>[~~<iso_date_or_interval>]
 * OBS~~<case_uuid>~~<surface_name>~~<attribute>~~<iso_date_or_interval>
 * ```
 *
 * The `<attribute>` component always spans three sub-components and says how the surface is identified:
 *
 * ```
 * TAGNAME~~<tagname>~~-
 * STDRES~~<standard_result>~~<sub_name>
 * ```
 *
 * A *TAGNAME* attribute matches the free text tagname the surface was exported with. A *STDRES* attribute matches an
 * FMU standard result, where `<sub_name>` discriminates between surfaces within that standard result, for example the
 * contact type for `fluid_contact_surface`. Unused components are set to "-".
 *
 * The `<stat_realizations>` component in a *STAT* address contains the list of realizations to include in the statistics
 * encoded as a `UintListStr` or "*" to include all realizations.
 */
export const postGetSurfaceIntersection = <ThrowOnError extends boolean = false>(
    options: Options<PostGetSurfaceIntersectionData_api, ThrowOnError>,
): RequestResult<PostGetSurfaceIntersectionResponses_api, PostGetSurfaceIntersectionErrors_api, ThrowOnError> =>
    (options.client ?? client).post<
        PostGetSurfaceIntersectionResponses_api,
        PostGetSurfaceIntersectionErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/get_surface_intersection",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Post Get Sample Surface In Points
 */
export const postGetSampleSurfaceInPoints = <ThrowOnError extends boolean = false>(
    options: Options<PostGetSampleSurfaceInPointsData_api, ThrowOnError>,
): RequestResult<PostGetSampleSurfaceInPointsResponses_api, PostGetSampleSurfaceInPointsErrors_api, ThrowOnError> =>
    (options.client ?? client).post<
        PostGetSampleSurfaceInPointsResponses_api,
        PostGetSampleSurfaceInPointsErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/surface/get_sample_surface_in_points",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Delta Surface Data
 */
export const getDeltaSurfaceData = <ThrowOnError extends boolean = false>(
    options: Options<GetDeltaSurfaceDataData_api, ThrowOnError>,
): RequestResult<GetDeltaSurfaceDataResponses_api, GetDeltaSurfaceDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetDeltaSurfaceDataResponses_api, GetDeltaSurfaceDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/surface/delta_surface_data",
        ...options,
        query: { ...options.query, _schema: "95b4bbea845a7805" },
    });

/**
 * Get Misfit Surface Data
 */
export const getMisfitSurfaceData = <ThrowOnError extends boolean = false>(
    options: Options<GetMisfitSurfaceDataData_api, ThrowOnError>,
): RequestResult<GetMisfitSurfaceDataResponses_api, GetMisfitSurfaceDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetMisfitSurfaceDataResponses_api, GetMisfitSurfaceDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/surface/misfit_surface_data",
        ...options,
        query: { ...options.query, _schema: "e676697b97d96a5d" },
    });

/**
 * Get Parameters And Sensitivities
 */
export const getParametersAndSensitivities = <ThrowOnError extends boolean = false>(
    options: Options<GetParametersAndSensitivitiesData_api, ThrowOnError>,
): RequestResult<GetParametersAndSensitivitiesResponses_api, GetParametersAndSensitivitiesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetParametersAndSensitivitiesResponses_api,
        GetParametersAndSensitivitiesErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/parameters/parameters_and_sensitivities/",
        ...options,
        query: { ...options.query, _schema: "c609c0d6991dca80" },
    });

/**
 * Get Grid Models Info
 *
 * Get metadata for all 3D grid models, including bbox, dimensions and properties
 */
export const getGridModelsInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetGridModelsInfoData_api, ThrowOnError>,
): RequestResult<GetGridModelsInfoResponses_api, GetGridModelsInfoErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetGridModelsInfoResponses_api, GetGridModelsInfoErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/grid3d/grid_models_info/",
        ...options,
        query: { ...options.query, _schema: "84c43c202f8c7e90" },
    });

/**
 * Get Grid Surface
 *
 * Get a grid
 */
export const getGridSurface = <ThrowOnError extends boolean = false>(
    options: Options<GetGridSurfaceData_api, ThrowOnError>,
): RequestResult<GetGridSurfaceResponses_api, GetGridSurfaceErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetGridSurfaceResponses_api, GetGridSurfaceErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/grid3d/grid_surface",
        ...options,
        query: { ...options.query, _schema: "79cbd6695772f171" },
    });

/**
 * Get Grid Parameter
 *
 * Get a grid parameter
 */
export const getGridParameter = <ThrowOnError extends boolean = false>(
    options: Options<GetGridParameterData_api, ThrowOnError>,
): RequestResult<GetGridParameterResponses_api, GetGridParameterErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetGridParameterResponses_api, GetGridParameterErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/grid3d/grid_parameter",
        ...options,
        query: { ...options.query, _schema: "3041db9332a5d885" },
    });

/**
 * Post Get Polyline Intersection
 *
 * Get the intersection of a polyline with the grid, including intersected cells and interpolated parameter values at intersection points
 */
export const postGetPolylineIntersection = <ThrowOnError extends boolean = false>(
    options: Options<PostGetPolylineIntersectionData_api, ThrowOnError>,
): RequestResult<PostGetPolylineIntersectionResponses_api, PostGetPolylineIntersectionErrors_api, ThrowOnError> =>
    (options.client ?? client).post<
        PostGetPolylineIntersectionResponses_api,
        PostGetPolylineIntersectionErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/grid3d/get_polyline_intersection",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Realization Flow Network
 *
 * Get flow network data for single realization
 */
export const getRealizationFlowNetwork = <ThrowOnError extends boolean = false>(
    options: Options<GetRealizationFlowNetworkData_api, ThrowOnError>,
): RequestResult<GetRealizationFlowNetworkResponses_api, GetRealizationFlowNetworkErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetRealizationFlowNetworkResponses_api,
        GetRealizationFlowNetworkErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/flow_network/realization_flow_network/",
        ...options,
        query: { ...options.query, _schema: "d9d317d36b7142f0" },
    });

/**
 * Get Production Data
 *
 * Get allocated production per well in the time interval
 */
export const getProductionData = <ThrowOnError extends boolean = false>(
    options: Options<GetProductionDataData_api, ThrowOnError>,
): RequestResult<GetProductionDataResponses_api, GetProductionDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetProductionDataResponses_api, GetProductionDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/flow_data/production_data/",
        ...options,
        query: { ...options.query, _schema: "e75a4edf23f57fc4" },
    });

/**
 * Get Injection Data
 *
 * Get allocated injection per well in the time interval
 */
export const getInjectionData = <ThrowOnError extends boolean = false>(
    options: Options<GetInjectionDataData_api, ThrowOnError>,
): RequestResult<GetInjectionDataResponses_api, GetInjectionDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetInjectionDataResponses_api, GetInjectionDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/flow_data/injection_data/",
        ...options,
        query: { ...options.query, _schema: "eee1b30313927a69" },
    });

/**
 * Get Pvt Table Data
 *
 * Get pvt table data for a given Sumo ensemble and realization
 */
export const getPvtTableData = <ThrowOnError extends boolean = false>(
    options: Options<GetPvtTableDataData_api, ThrowOnError>,
): RequestResult<GetPvtTableDataResponses_api, GetPvtTableDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetPvtTableDataResponses_api, GetPvtTableDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/pvt/pvt_table_data/",
        ...options,
        query: { ...options.query, _schema: "9ddf814ace500cc4" },
    });

/**
 * Get Well Completions Data
 */
export const getWellCompletionsData = <ThrowOnError extends boolean = false>(
    options: Options<GetWellCompletionsDataData_api, ThrowOnError>,
): RequestResult<GetWellCompletionsDataResponses_api, GetWellCompletionsDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetWellCompletionsDataResponses_api, GetWellCompletionsDataErrors_api, ThrowOnError>(
        {
            responseType: "json",
            url: "/well_completions/well_completions_data/",
            ...options,
            query: { ...options.query, _schema: "3fb75a148e89dd58" },
        },
    );

/**
 * Get Drilled Wellbore Headers
 *
 * Get wellbore headers for all wells in a given field
 */
export const getDrilledWellboreHeaders = <ThrowOnError extends boolean = false>(
    options: Options<GetDrilledWellboreHeadersData_api, ThrowOnError>,
): RequestResult<GetDrilledWellboreHeadersResponses_api, GetDrilledWellboreHeadersErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetDrilledWellboreHeadersResponses_api,
        GetDrilledWellboreHeadersErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/drilled_wellbore_headers/",
        ...options,
        query: { ...options.query, _schema: "9f35b94a66d7b720" },
    });

/**
 * Get Planned Wellbore Headers
 *
 * Get planned wellbore headers for all planned wells in a given field
 */
export const getPlannedWellboreHeaders = <ThrowOnError extends boolean = false>(
    options: Options<GetPlannedWellboreHeadersData_api, ThrowOnError>,
): RequestResult<GetPlannedWellboreHeadersResponses_api, GetPlannedWellboreHeadersErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetPlannedWellboreHeadersResponses_api,
        GetPlannedWellboreHeadersErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/planned_wellbore_headers/",
        ...options,
        query: { ...options.query, _schema: "25e410062a26a87d" },
    });

/**
 * Get Field Perforations
 *
 * Get field perforations for all wellbores in a given field.
 */
export const getFieldPerforations = <ThrowOnError extends boolean = false>(
    options: Options<GetFieldPerforationsData_api, ThrowOnError>,
): RequestResult<GetFieldPerforationsResponses_api, GetFieldPerforationsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetFieldPerforationsResponses_api, GetFieldPerforationsErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/well/field_perforations",
        ...options,
        query: { ...options.query, _schema: "3e7ff38a4fa57ceb" },
    });

/**
 * Get Field Screens
 *
 * Get field screens for all wellbores in a given field.
 * Screens are the SSDL completions with a filter on "Screen" type.
 */
export const getFieldScreens = <ThrowOnError extends boolean = false>(
    options: Options<GetFieldScreensData_api, ThrowOnError>,
): RequestResult<GetFieldScreensResponses_api, GetFieldScreensErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetFieldScreensResponses_api, GetFieldScreensErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/well/field_screens",
        ...options,
        query: { ...options.query, _schema: "dfa54b9d4fca7ee4" },
    });

/**
 * Get Well Trajectories
 *
 * Get trajectories for wellbores in a given field. Can optionally return only a subset if a list of uuids are given
 */
export const getWellTrajectories = <ThrowOnError extends boolean = false>(
    options: Options<GetWellTrajectoriesData_api, ThrowOnError>,
): RequestResult<GetWellTrajectoriesResponses_api, GetWellTrajectoriesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetWellTrajectoriesResponses_api, GetWellTrajectoriesErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/well/well_trajectories/",
        ...options,
        query: { ...options.query, _schema: "8385e68cd04bfabb" },
    });

/**
 * Get Planned Well Trajectories
 *
 * Get planned trajectories for wellbores in a given field. Can optionally return only a subset if a list of uuids are given
 */
export const getPlannedWellTrajectories = <ThrowOnError extends boolean = false>(
    options: Options<GetPlannedWellTrajectoriesData_api, ThrowOnError>,
): RequestResult<GetPlannedWellTrajectoriesResponses_api, GetPlannedWellTrajectoriesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetPlannedWellTrajectoriesResponses_api,
        GetPlannedWellTrajectoriesErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/planned_well_trajectories/",
        ...options,
        query: { ...options.query, _schema: "a2672a592e989476" },
    });

/**
 * Get Wellbore Pick Identifiers
 *
 * Get wellbore pick identifiers for a given stratigraphic column
 */
export const getWellborePickIdentifiers = <ThrowOnError extends boolean = false>(
    options: Options<GetWellborePickIdentifiersData_api, ThrowOnError>,
): RequestResult<GetWellborePickIdentifiersResponses_api, GetWellborePickIdentifiersErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetWellborePickIdentifiersResponses_api,
        GetWellborePickIdentifiersErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_pick_identifiers/",
        ...options,
        query: { ...options.query, _schema: "5b8a12937018e2d3" },
    });

/**
 * Get Wellbore Picks For Pick Identifier
 *
 * Get wellbore picks for a field and pick identifier
 *
 * This implies picks for multiple wellbores for given field and pick identifier.
 * E.g. picks for all wellbores in a given surface in a field.
 */
export const getWellborePicksForPickIdentifier = <ThrowOnError extends boolean = false>(
    options: Options<GetWellborePicksForPickIdentifierData_api, ThrowOnError>,
): RequestResult<
    GetWellborePicksForPickIdentifierResponses_api,
    GetWellborePicksForPickIdentifierErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetWellborePicksForPickIdentifierResponses_api,
        GetWellborePicksForPickIdentifierErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_picks_for_pick_identifier/",
        ...options,
        query: { ...options.query, _schema: "ad11dc9889f59d4e" },
    });

/**
 * Get Wellbore Picks In Strat Column
 *
 * Get wellbore picks for a single wellbore within stratigraphic column
 */
export const getWellborePicksInStratColumn = <ThrowOnError extends boolean = false>(
    options: Options<GetWellborePicksInStratColumnData_api, ThrowOnError>,
): RequestResult<GetWellborePicksInStratColumnResponses_api, GetWellborePicksInStratColumnErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetWellborePicksInStratColumnResponses_api,
        GetWellborePicksInStratColumnErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_picks_in_strat_column",
        ...options,
        query: { ...options.query, _schema: "979713cc19484267" },
    });

/**
 * Get Wellbore Stratigraphic Columns
 *
 * Get stratigraphic columns for a given wellbore
 */
export const getWellboreStratigraphicColumns = <ThrowOnError extends boolean = false>(
    options: Options<GetWellboreStratigraphicColumnsData_api, ThrowOnError>,
): RequestResult<
    GetWellboreStratigraphicColumnsResponses_api,
    GetWellboreStratigraphicColumnsErrors_api,
    ThrowOnError
> =>
    (options.client ?? client).get<
        GetWellboreStratigraphicColumnsResponses_api,
        GetWellboreStratigraphicColumnsErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_stratigraphic_columns/",
        ...options,
        query: { ...options.query, _schema: "90047d19aca7c8eb" },
    });

/**
 * Get Wellbore Completions
 *
 * Get wellbore completions for a given wellbore
 */
export const getWellboreCompletions = <ThrowOnError extends boolean = false>(
    options: Options<GetWellboreCompletionsData_api, ThrowOnError>,
): RequestResult<GetWellboreCompletionsResponses_api, GetWellboreCompletionsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetWellboreCompletionsResponses_api, GetWellboreCompletionsErrors_api, ThrowOnError>(
        {
            responseType: "json",
            url: "/well/wellbore_completions/",
            ...options,
            query: { ...options.query, _schema: "e1bb0e4ae4c5fb6e" },
        },
    );

/**
 * Get Wellbore Casings
 *
 * Get wellbore casings for a given wellbore
 */
export const getWellboreCasings = <ThrowOnError extends boolean = false>(
    options: Options<GetWellboreCasingsData_api, ThrowOnError>,
): RequestResult<GetWellboreCasingsResponses_api, GetWellboreCasingsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetWellboreCasingsResponses_api, GetWellboreCasingsErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/well/wellbore_casings/",
        ...options,
        query: { ...options.query, _schema: "dc609d73e6b7231e" },
    });

/**
 * Get Wellbore Perforations
 *
 * Get wellbore perforations for a given wellbore
 */
export const getWellborePerforations = <ThrowOnError extends boolean = false>(
    options: Options<GetWellborePerforationsData_api, ThrowOnError>,
): RequestResult<GetWellborePerforationsResponses_api, GetWellborePerforationsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetWellborePerforationsResponses_api,
        GetWellborePerforationsErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_perforations/",
        ...options,
        query: { ...options.query, _schema: "9ab160463764c3ad" },
    });

/**
 * Get Wellbore Log Curve Headers
 *
 * Get all log curve headers for a single well bore.
 * Logs are available from multiple sources, which can be specificed by the "sources" parameter.
 */
export const getWellboreLogCurveHeaders = <ThrowOnError extends boolean = false>(
    options: Options<GetWellboreLogCurveHeadersData_api, ThrowOnError>,
): RequestResult<GetWellboreLogCurveHeadersResponses_api, GetWellboreLogCurveHeadersErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetWellboreLogCurveHeadersResponses_api,
        GetWellboreLogCurveHeadersErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/well/wellbore_log_curve_headers/",
        ...options,
        query: { ...options.query, _schema: "8ba0462e581cac25" },
    });

/**
 * Get Log Curve Data
 *
 * Get log curve data
 */
export const getLogCurveData = <ThrowOnError extends boolean = false>(
    options: Options<GetLogCurveDataData_api, ThrowOnError>,
): RequestResult<GetLogCurveDataResponses_api, GetLogCurveDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetLogCurveDataResponses_api, GetLogCurveDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/well/log_curve_data/",
        ...options,
        query: { ...options.query, _schema: "b6e97cb35a73f1c9" },
    });

/**
 * Get Seismic Cube Meta List
 *
 * Get a list of seismic cube meta.
 */
export const getSeismicCubeMetaList = <ThrowOnError extends boolean = false>(
    options: Options<GetSeismicCubeMetaListData_api, ThrowOnError>,
): RequestResult<GetSeismicCubeMetaListResponses_api, GetSeismicCubeMetaListErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSeismicCubeMetaListResponses_api, GetSeismicCubeMetaListErrors_api, ThrowOnError>(
        {
            responseType: "json",
            url: "/seismic/seismic_cube_meta_list/",
            ...options,
            query: { ...options.query, _schema: "68715e4e4429aa85" },
        },
    );

/**
 * Get Seismic Slices
 *
 * Get a seismic depth slice from a seismic cube.
 */
export const getSeismicSlices = <ThrowOnError extends boolean = false>(
    options: Options<GetSeismicSlicesData_api, ThrowOnError>,
): RequestResult<GetSeismicSlicesResponses_api, GetSeismicSlicesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSeismicSlicesResponses_api, GetSeismicSlicesErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/seismic/get_seismic_slices/",
        ...options,
        query: { ...options.query, _schema: "11b19cbd00097d87" },
    });

/**
 * Post Get Seismic Fence
 *
 * Get a fence of seismic data from a polyline defined by a set of (x, y) coordinates in domain coordinate system.
 *
 * The fence data contains a set of traces perpendicular to the polyline, with one trace per (x, y)-point in polyline.
 * Each trace has equal number of samples, and is a set of sample values along the depth direction of the seismic cube.
 *
 * Returns:
 * A SeismicFenceData object with fence traces in encoded 1D array, metadata for trace array decoding and fence min/max depth.
 */
export const postGetSeismicFence = <ThrowOnError extends boolean = false>(
    options: Options<PostGetSeismicFenceData_api, ThrowOnError>,
): RequestResult<PostGetSeismicFenceResponses_api, PostGetSeismicFenceErrors_api, ThrowOnError> =>
    (options.client ?? client).post<PostGetSeismicFenceResponses_api, PostGetSeismicFenceErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/seismic/get_seismic_fence/",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Polygons Directory
 *
 * Get a directory of polygons in a Sumo ensemble
 */
export const getPolygonsDirectory = <ThrowOnError extends boolean = false>(
    options: Options<GetPolygonsDirectoryData_api, ThrowOnError>,
): RequestResult<GetPolygonsDirectoryResponses_api, GetPolygonsDirectoryErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetPolygonsDirectoryResponses_api, GetPolygonsDirectoryErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/polygons/polygons_directory/",
        ...options,
        query: { ...options.query, _schema: "714e98619db49d56" },
    });

/**
 * Get Polygons Data
 */
export const getPolygonsData = <ThrowOnError extends boolean = false>(
    options: Options<GetPolygonsDataData_api, ThrowOnError>,
): RequestResult<GetPolygonsDataResponses_api, GetPolygonsDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetPolygonsDataResponses_api, GetPolygonsDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/polygons/polygons_data/",
        ...options,
        query: { ...options.query, _schema: "57d6180521f8e105" },
    });

/**
 * Get User Info
 */
export const getUserInfo = <ThrowOnError extends boolean = false>(
    options: Options<GetUserInfoData_api, ThrowOnError>,
): RequestResult<GetUserInfoResponses_api, GetUserInfoErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetUserInfoResponses_api, GetUserInfoErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/graph/user_info/{user_id_or_email}",
        ...options,
        query: { ...options.query, _schema: "44f8fc4b01dbf4ec" },
    });

/**
 * Get User Photo
 *
 * Get username, display name and avatar from Microsoft Graph API for a given user email or graph identity
 */
export const getUserPhoto = <ThrowOnError extends boolean = false>(
    options: Options<GetUserPhotoData_api, ThrowOnError>,
): RequestResult<GetUserPhotoResponses_api, GetUserPhotoErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetUserPhotoResponses_api, GetUserPhotoErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/graph/user_photo/",
        ...options,
        query: { ...options.query, _schema: "1fe1ad6e12e8ec16" },
    });

/**
 * Get Summary Observations
 *
 * Retrieve all summary observations found in ensemble
 */
export const getSummaryObservations = <ThrowOnError extends boolean = false>(
    options: Options<GetSummaryObservationsData_api, ThrowOnError>,
): RequestResult<GetSummaryObservationsResponses_api, GetSummaryObservationsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSummaryObservationsResponses_api, GetSummaryObservationsErrors_api, ThrowOnError>(
        {
            responseType: "json",
            url: "/observations/summary_observations",
            ...options,
            query: { ...options.query, _schema: "b80338504b88741a" },
        },
    );

/**
 * Get Relperm Table Names
 */
export const getRelpermTableNames = <ThrowOnError extends boolean = false>(
    options: Options<GetRelpermTableNamesData_api, ThrowOnError>,
): RequestResult<GetRelpermTableNamesResponses_api, GetRelpermTableNamesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetRelpermTableNamesResponses_api, GetRelpermTableNamesErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/relperm/table_names",
        ...options,
        query: { ...options.query, _schema: "1ff84c3dd3c6fe90" },
    });

/**
 * Get Relperm Table Definition
 */
export const getRelpermTableDefinition = <ThrowOnError extends boolean = false>(
    options: Options<GetRelpermTableDefinitionData_api, ThrowOnError>,
): RequestResult<GetRelpermTableDefinitionResponses_api, GetRelpermTableDefinitionErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetRelpermTableDefinitionResponses_api,
        GetRelpermTableDefinitionErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/relperm/table_definition",
        ...options,
        query: { ...options.query, _schema: "53b38ede3afbc339" },
    });

/**
 * Get Relperm Realization Data
 */
export const getRelpermRealizationData = <ThrowOnError extends boolean = false>(
    options: Options<GetRelpermRealizationDataData_api, ThrowOnError>,
): RequestResult<GetRelpermRealizationDataResponses_api, GetRelpermRealizationDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<
        GetRelpermRealizationDataResponses_api,
        GetRelpermRealizationDataErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/relperm/realization_data",
        ...options,
        query: { ...options.query, _schema: "e06a233497f31d9f" },
    });

/**
 * Get Rft Table Definition
 *
 * Get the RFT table definition for a given ensemble.
 */
export const getRftTableDefinition = <ThrowOnError extends boolean = false>(
    options: Options<GetRftTableDefinitionData_api, ThrowOnError>,
): RequestResult<GetRftTableDefinitionResponses_api, GetRftTableDefinitionErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetRftTableDefinitionResponses_api, GetRftTableDefinitionErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/rft/rft_table_definition",
        ...options,
        query: { ...options.query, _schema: "242418106e27c07f" },
    });

/**
 * Get Rft Realization Data
 *
 * Get a list of RFT data per realization, for a given well and response.
 */
export const getRftRealizationData = <ThrowOnError extends boolean = false>(
    options: Options<GetRftRealizationDataData_api, ThrowOnError>,
): RequestResult<GetRftRealizationDataResponses_api, GetRftRealizationDataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetRftRealizationDataResponses_api, GetRftRealizationDataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/rft/rft_realization_data",
        ...options,
        query: { ...options.query, _schema: "70557ae423b293cb" },
    });

/**
 * Get Rft Observations
 *
 * Get RFT observations per well and date for a given ensemble.
 */
export const getRftObservations = <ThrowOnError extends boolean = false>(
    options: Options<GetRftObservationsData_api, ThrowOnError>,
): RequestResult<GetRftObservationsResponses_api, GetRftObservationsErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetRftObservationsResponses_api, GetRftObservationsErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/rft/rft_observations",
        ...options,
        query: { ...options.query, _schema: "cf11fc6294784ba9" },
    });

/**
 * Get Vfp Tables
 *
 * Get the available VFP tables (type and number) for a given ensemble and realization.
 */
export const getVfpTables = <ThrowOnError extends boolean = false>(
    options: Options<GetVfpTablesData_api, ThrowOnError>,
): RequestResult<GetVfpTablesResponses_api, GetVfpTablesErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetVfpTablesResponses_api, GetVfpTablesErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/vfp/vfp_tables/",
        ...options,
        query: { ...options.query, _schema: "4c775b21a1bbec7d" },
    });

/**
 * Get Vfp Table
 *
 * Get the VFP table for a given ensemble, realization, type and table number.
 */
export const getVfpTable = <ThrowOnError extends boolean = false>(
    options: Options<GetVfpTableData_api, ThrowOnError>,
): RequestResult<GetVfpTableResponses_api, GetVfpTableErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetVfpTableResponses_api, GetVfpTableErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/vfp/vfp_table/",
        ...options,
        query: { ...options.query, _schema: "47651ec5b112bc29" },
    });

/**
 * Get Sessions Metadata
 *
 * Get a paginated list of session metadata for the authenticated user.
 *
 * This endpoint returns session metadata (without content) with support for:
 * - **Pagination**: Use the continuation token to fetch subsequent pages
 * - **Sorting**: Sort by various fields in ascending or descending order
 * - **Case-insensitive sorting**: Optional lowercase sorting for text fields
 * - **Filtering**: Filter by title and date ranges
 *
 * The response includes a continuation token for fetching the next page of results.
 */
export const getSessionsMetadata = <ThrowOnError extends boolean = false>(
    options?: Options<GetSessionsMetadataData_api, ThrowOnError>,
): RequestResult<GetSessionsMetadataResponses_api, GetSessionsMetadataErrors_api, ThrowOnError> =>
    (options?.client ?? client).get<GetSessionsMetadataResponses_api, GetSessionsMetadataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions",
        ...options,
        query: { ...options?.query, _schema: "caab5a43664d3134" },
    });

/**
 * Create Session
 *
 * Create a new session for the authenticated user.
 *
 * Provide:
 * - **title**: Session title (required)
 * - **description**: Optional description
 * - **content**: Session content (required)
 *
 * The system automatically generates:
 * - Unique session ID
 * - Creation and update timestamps
 * - Version number (starts at 1)
 * - Content hash for integrity checking
 *
 * Returns the ID of the newly created session.
 */
export const createSession = <ThrowOnError extends boolean = false>(
    options: Options<CreateSessionData_api, ThrowOnError>,
): RequestResult<CreateSessionResponses_api, CreateSessionErrors_api, ThrowOnError> =>
    (options.client ?? client).post<CreateSessionResponses_api, CreateSessionErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Delete Session
 *
 * Permanently delete a session.
 *
 * This operation:
 * - Removes the session document from the database
 * - Cannot be undone
 * - Requires ownership verification
 *
 * Only the session owner can delete their sessions.
 */
export const deleteSession = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSessionData_api, ThrowOnError>,
): RequestResult<DeleteSessionResponses_api, DeleteSessionErrors_api, ThrowOnError> =>
    (options.client ?? client).delete<DeleteSessionResponses_api, DeleteSessionErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions/{session_id}",
        ...options,
    });

/**
 * Get Session
 *
 * Retrieve a complete session by its ID.
 *
 * Returns the full session document including:
 * - Session metadata (title, description, timestamps, version, etc.)
 * - Complete session content
 *
 * Only the session owner can access this endpoint.
 */
export const getSession = <ThrowOnError extends boolean = false>(
    options: Options<GetSessionData_api, ThrowOnError>,
): RequestResult<GetSessionResponses_api, GetSessionErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSessionResponses_api, GetSessionErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions/{session_id}",
        ...options,
        query: { ...options.query, _schema: "b8451456f2183e71" },
    });

/**
 * Update Session
 *
 * Update an existing session with partial or complete changes.
 *
 * You can update any combination of:
 * - **title**: New session title
 * - **description**: New description
 * - **content**: New session content
 *
 * All fields are optional - only provided fields will be updated.
 *
 * The system automatically:
 * - Updates the `updated_at` timestamp
 * - Increments the version number
 * - Recalculates the content hash if content changed
 * - Preserves ownership and creation metadata
 *
 * Returns the complete updated session.
 *
 * Only the session owner can update their sessions.
 */
export const updateSession = <ThrowOnError extends boolean = false>(
    options: Options<UpdateSessionData_api, ThrowOnError>,
): RequestResult<UpdateSessionResponses_api, UpdateSessionErrors_api, ThrowOnError> =>
    (options.client ?? client).put<UpdateSessionResponses_api, UpdateSessionErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions/{session_id}",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Get Session Metadata
 *
 * Retrieve only the metadata for a specific session.
 *
 * Returns session metadata without the content, useful for:
 * - Listing sessions with details
 * - Checking version or timestamps
 * - Lightweight operations that don't need full content
 *
 * Only the session owner can access this endpoint.
 */
export const getSessionMetadata = <ThrowOnError extends boolean = false>(
    options: Options<GetSessionMetadataData_api, ThrowOnError>,
): RequestResult<GetSessionMetadataResponses_api, GetSessionMetadataErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSessionMetadataResponses_api, GetSessionMetadataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/sessions/metadata/{session_id}",
        ...options,
        query: { ...options.query, _schema: "d453600100e5922e" },
    });

/**
 * Get Snapshot Access Logs
 *
 * Get a list of all snapshots you have visited.
 *
 * This endpoint tracks your interaction history with snapshots, including:
 * - Snapshots you've created (counted as implicit visits)
 * - Snapshots you've viewed
 * - Snapshots shared with you that you've accessed
 *
 * Each access log entry includes:
 * - **Visit count**: Number of times you've viewed the snapshot
 * - **First visited**: Timestamp of your first visit
 * - **Last visited**: Timestamp of your most recent visit
 * - **Snapshot metadata**: Title, description, creation date
 * - **Deletion status**: Whether the snapshot has been deleted
 *
 * Supports pagination, sorting, and filtering by:
 * - Title (case insensitive)
 * - Creation date range
 * - Last visited date range
 */
export const getSnapshotAccessLogs = <ThrowOnError extends boolean = false>(
    options?: Options<GetSnapshotAccessLogsData_api, ThrowOnError>,
): RequestResult<GetSnapshotAccessLogsResponses_api, GetSnapshotAccessLogsErrors_api, ThrowOnError> =>
    (options?.client ?? client).get<GetSnapshotAccessLogsResponses_api, GetSnapshotAccessLogsErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/snapshot_access_logs",
        ...options,
        query: { ...options?.query, _schema: "16e8d475160b8804" },
    });

/**
 * Get Snapshots Metadata
 *
 * Get a paginated list of your snapshot metadata.
 *
 * Returns metadata for snapshots you own (without content) with support for:
 * - **Pagination**: Use continuation tokens for large result sets
 * - **Sorting**: Sort by title, creation date, etc.
 * - **Filtering**: Filter by title and date ranges
 *
 * Snapshots are immutable records that can be shared with others.
 * They are separate from sessions and are intended for point-in-time captures.
 *
 * Note: Consider using `/persistence/snapshot_access_logs` to see both your snapshots and ones shared with you.
 */
export const getSnapshotsMetadata = <ThrowOnError extends boolean = false>(
    options?: Options<GetSnapshotsMetadataData_api, ThrowOnError>,
): RequestResult<GetSnapshotsMetadataResponses_api, GetSnapshotsMetadataErrors_api, ThrowOnError> =>
    (options?.client ?? client).get<GetSnapshotsMetadataResponses_api, GetSnapshotsMetadataErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/snapshots",
        ...options,
        query: { ...options?.query, _schema: "29aa2f963cdff19c" },
    });

/**
 * Create Snapshot
 *
 * Create a new snapshot for point-in-time capture.
 *
 * Provide:
 * - **title**: Snapshot title (required)
 * - **description**: Optional description
 * - **content**: Snapshot content (required)
 *
 * The system automatically:
 * - Generates a unique snapshot ID
 * - Records creation timestamp
 * - Calculates content hash for integrity
 * - **Logs an implicit visit** (so it appears in your visited snapshots)
 *
 * Snapshots are immutable and can be shared with others via their ID.
 *
 * Returns the ID of the newly created snapshot.
 */
export const createSnapshot = <ThrowOnError extends boolean = false>(
    options: Options<CreateSnapshotData_api, ThrowOnError>,
): RequestResult<CreateSnapshotResponses_api, CreateSnapshotErrors_api, ThrowOnError> =>
    (options.client ?? client).post<CreateSnapshotResponses_api, CreateSnapshotErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/snapshots",
        ...options,
        headers: {
            "Content-Type": "application/json",
            ...options.headers,
        },
    });

/**
 * Delete Snapshot
 *
 * Permanently delete a snapshot.
 *
 * This operation:
 * - Removes the snapshot document from the database
 * - Marks all access logs as deleted (background task)
 * - Cannot be undone
 * - Requires ownership verification
 *
 * **Background Processing:**
 * Access logs are marked as deleted asynchronously to avoid blocking the response.
 * This typically completes within seconds for snapshots with <150 visitor logs.
 *
 * Only the snapshot owner can delete their snapshots.
 */
export const deleteSnapshot = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSnapshotData_api, ThrowOnError>,
): RequestResult<DeleteSnapshotResponses_api, DeleteSnapshotErrors_api, ThrowOnError> =>
    (options.client ?? client).delete<DeleteSnapshotResponses_api, DeleteSnapshotErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/snapshots/{snapshot_id}",
        ...options,
    });

/**
 * Get Snapshot
 *
 * Retrieve a complete snapshot by its ID.
 *
 * Returns the full snapshot document including:
 * - Snapshot metadata (title, description, creation date, etc.)
 * - Complete snapshot content
 *
 * **Important**: This endpoint automatically tracks your visit:
 * - Increments the visit counter
 * - Updates the "last visited" timestamp
 * - Creates an access log entry if this is your first visit
 *
 * This allows you to see your viewing history in `/persistence/snapshot_access_logs`.
 *
 * Any user with the snapshot ID can access snapshots (they are shareable).
 */
export const getSnapshot = <ThrowOnError extends boolean = false>(
    options: Options<GetSnapshotData_api, ThrowOnError>,
): RequestResult<GetSnapshotResponses_api, GetSnapshotErrors_api, ThrowOnError> =>
    (options.client ?? client).get<GetSnapshotResponses_api, GetSnapshotErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/persistence/snapshots/{snapshot_id}",
        ...options,
        query: { ...options.query, _schema: "e313826e82e01e9b" },
    });

/**
 * Delete Snapshot Access Log
 *
 * Delete your access log for a specific snapshot.
 *
 * This operation:
 * - Removes your access log entry for the given snapshot
 * - Does NOT affect the snapshot itself or other users' logs
 *
 * Use this endpoint to clear your visit history for a snapshot
 * without deleting the snapshot or impacting other users.
 */
export const deleteSnapshotAccessLog = <ThrowOnError extends boolean = false>(
    options: Options<DeleteSnapshotAccessLogData_api, ThrowOnError>,
): RequestResult<DeleteSnapshotAccessLogResponses_api, DeleteSnapshotAccessLogErrors_api, ThrowOnError> =>
    (options.client ?? client).delete<
        DeleteSnapshotAccessLogResponses_api,
        DeleteSnapshotAccessLogErrors_api,
        ThrowOnError
    >({
        responseType: "json",
        url: "/persistence/snapshot_access_logs/{snapshot_id}",
        ...options,
    });

/**
 * Get Media Sas Token
 *
 * Return a short-lived, read-only container SAS token for fetching tutorial media.
 */
export const getMediaSasToken = <ThrowOnError extends boolean = false>(
    options?: Options<GetMediaSasTokenData_api, ThrowOnError>,
): RequestResult<GetMediaSasTokenResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<GetMediaSasTokenResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/tutorials/media_sas_token",
        ...options,
        query: { ...options?.query, _schema: "86edc310328d24ad" },
    });

/**
 *  Login Route
 */
export const loginRoute = <ThrowOnError extends boolean = false>(
    options?: Options<LoginRouteData_api, ThrowOnError>,
): RequestResult<LoginRouteResponses_api, LoginRouteErrors_api, ThrowOnError> =>
    (options?.client ?? client).get<LoginRouteResponses_api, LoginRouteErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/login",
        ...options,
        query: { ...options?.query, _schema: "fd0448008a4cafdf" },
    });

/**
 *  Authorized Callback Route
 */
export const authorizedCallbackRoute = <ThrowOnError extends boolean = false>(
    options?: Options<AuthorizedCallbackRouteData_api, ThrowOnError>,
): RequestResult<AuthorizedCallbackRouteResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<AuthorizedCallbackRouteResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/auth-callback",
        ...options,
        query: { ...options?.query, _schema: "fd0448008a4cafdf" },
    });

/**
 * Get Alive
 */
export const getAlive = <ThrowOnError extends boolean = false>(
    options?: Options<GetAliveData_api, ThrowOnError>,
): RequestResult<GetAliveResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<GetAliveResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/alive",
        ...options,
        query: { ...options?.query, _schema: "f946f0c572e55767" },
    });

/**
 * Get Alive Protected
 */
export const getAliveProtected = <ThrowOnError extends boolean = false>(
    options?: Options<GetAliveProtectedData_api, ThrowOnError>,
): RequestResult<GetAliveProtectedResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<GetAliveProtectedResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/alive_protected",
        ...options,
        query: { ...options?.query, _schema: "2787bd42badd2c19" },
    });

/**
 * Post Logout
 */
export const postLogout = <ThrowOnError extends boolean = false>(
    options?: Options<PostLogoutData_api, ThrowOnError>,
): RequestResult<PostLogoutResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).post<PostLogoutResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/logout",
        ...options,
    });

/**
 * Get Logged In User
 */
export const getLoggedInUser = <ThrowOnError extends boolean = false>(
    options?: Options<GetLoggedInUserData_api, ThrowOnError>,
): RequestResult<GetLoggedInUserResponses_api, GetLoggedInUserErrors_api, ThrowOnError> =>
    (options?.client ?? client).get<GetLoggedInUserResponses_api, GetLoggedInUserErrors_api, ThrowOnError>({
        responseType: "json",
        url: "/logged_in_user",
        ...options,
        query: { ...options?.query, _schema: "e636f695c93610cd" },
    });

/**
 * Root
 */
export const root = <ThrowOnError extends boolean = false>(
    options?: Options<RootData_api, ThrowOnError>,
): RequestResult<RootResponses_api, unknown, ThrowOnError> =>
    (options?.client ?? client).get<RootResponses_api, unknown, ThrowOnError>({
        responseType: "json",
        url: "/",
        ...options,
        query: { ...options?.query, _schema: "38794f509991ed60" },
    });
